<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ack"> </p>
<p class="FMH"><span href="#/xhtml/contents#c_ack" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></p>
<p class="FMTNI">Once more thanks to Monique Patterson for her fabulous editing, my agent Helen Breitweiser for her wonderful agenting, and to my family for bearing with me.</p>
<p class="FMTX">Also to the most excellent Megan Crane for giving me Zac pointers. Doms, indeed, do not hold back.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?16e1fe2d